'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getPathFileExt(uri) {
    var uriObj = new URL(uri);
    var uriPieces = uriObj.pathname.split('/');
    var uriFilename = uriPieces.pop();
    var filenamePieces = uriFilename.split('.');
    // Only one piece means there is no extension.
    if (filenamePieces.length == 1) {
        return null;
    }
    return filenamePieces.pop().toLowerCase();
}

exports.getPathFileExt = getPathFileExt;
